import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { configRefs } from '@utils/constants';

const twentyThreeAudioSchema = z.object({
  id: z.string(),
  title: z.string(),
  downloadPath: z.string(),
  standardThumbnail: z.string(),
  audioTranscript: z.array(z.object({
    timestamp_begin: z.number(),
    timestamp_end: z.number(),
    text: z.array(z.string())
  })).nullish().default(null)
}).transform(({
  audioTranscript,
  downloadPath,
  standardThumbnail,
  ...rest
}) => {
  return {
    ...rest,
    src: `${configRefs.apis.video23.audio.dangerouslyAssertSyncValue()}${downloadPath}`,
    thumbnailSrc: `${configRefs.apis.video23.audio.dangerouslyAssertSyncValue()}${standardThumbnail}`,
    transcript: audioTranscript ? xml2ast(audioTranscript.map(it => it.text.join("<br>")).join(" "), allHtmlParsers, "text/html") : null
  };
}).nullish().default(null);

export { twentyThreeAudioSchema };
//# sourceMappingURL=schema.twenty-three-audio.js.map
